module.exports = __webpack_public_path__ + "img/youjinsuoLogo.710c374e.png";